(function(){
  if(window.__ironsidePreorderLoaded) return;
  window.__ironsidePreorderLoaded = true;

  function parseVariantDates(raw){
    try{
      return JSON.parse(raw || "[]");
    }catch(e){
      return [];
    }
  }

  function getVariantIdFromUrl(){
    var params = new URLSearchParams(window.location.search);
    return params.get("variant");
  }

  function getSelectedVariantId(container){
    var urlVariant = getVariantIdFromUrl();
    if(urlVariant) return urlVariant;

    var scope = container.closest("product-info") || container.closest("section") || document;
    var idInput = scope.querySelector('form[action*="/cart/add"] [name="id"]');

    if(idInput && idInput.value) return idInput.value;

    return container.getAttribute("data-current-variant-id") || "";
  }

  function formatDate(value){
    if(!value) return "";

    var raw = String(value).trim();

    if(/^\d{4}-\d{2}-\d{2}$/.test(raw)){
      var parts = raw.split("-");
      var date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));

      return date.toLocaleDateString("es-MX", {
        day:"2-digit",
        month:"long",
        year:"numeric"
      });
    }

    return raw;
  }

  function updatePreorder(container){
    var variantId = getSelectedVariantId(container);
    var productDate = container.getAttribute("data-product-date") || "";
    var variantDates = parseVariantDates(container.getAttribute("data-variant-dates"));

    var match = variantDates.find(function(item){
      return String(item.id) === String(variantId);
    });

    var dateValue = match && match.date ? match.date : productDate;
    var target = container.querySelector("[data-dispatch-date]");

    if(!dateValue){
      container.hidden = true;
      return;
    }

    if(target) target.textContent = formatDate(dateValue);
    container.hidden = false;
  }

  function updateAll(){
    document.querySelectorAll("[data-ironside-preorder]").forEach(updatePreorder);
  }

  function scheduleUpdate(){
    window.setTimeout(updateAll, 80);
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", updateAll);
  }else{
    updateAll();
  }

  document.addEventListener("change", function(event){
    if(event.target.matches('[name="id"],select,input[type="radio"]')) scheduleUpdate();
  });

  document.addEventListener("variant:change", scheduleUpdate);
  document.addEventListener("shopify:section:load", scheduleUpdate);

  var originalPushState = history.pushState;
  var originalReplaceState = history.replaceState;

  history.pushState = function(){
    originalPushState.apply(this, arguments);
    scheduleUpdate();
  };

  history.replaceState = function(){
    originalReplaceState.apply(this, arguments);
    scheduleUpdate();
  };

  window.addEventListener("popstate", scheduleUpdate);
})();